import { createContext } from "react";

export const GameStateContext = createContext("");